var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"ma-0"},[_c('v-card',{staticClass:"mx-auto mt-10",attrs:{"max-width":"800","flat":"","color":"background"}},[_c('v-img',{attrs:{"src":require("@/assets/images/bf-science.png"),"eager":""}}),_c('v-card-text',[_c('h1',{staticClass:"mx-4 headline grey--text text-center"},[_vm._v(" Beanfee Control Panel ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }